<template>
  <div class="notice_detail">
    <div class="title">{{ activityDetail.noticeTitle }}</div>
    <div class="content" v-html="activityDetail.scope"></div>
    <div class="time">{{ activityDetail.createDate | filterTime }}</div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  data() {
    return {
      activityDetail: {
        noticeTitle: '',
        scope: ''
      },
      richTextContent: "", // 富文本内容
      noticeTitle: "", // 公告标题
    };
  },
  filters: {
    filterTime(date) {
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
  },
  created() {
    this.activityDetail = JSON.parse(sessionStorage.getItem('activityDetail'))
    console.log(this.activityDetail)
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.notice_detail {
  padding: 20px;
  box-sizing: border-box;
  text-align: left;
  :deep img {
    width: 100%;
    max-width: 100%;
  }
  :deep table {
    max-width: 100%;
    word-break: break-all;
  }
  .title {
    color: #000;
    font-weight: bold;
    margin-bottom: 10px;
    text-align: center;
    font-size: 14px;
  }
  .content {
    overflow-y: auto;
    line-height: 22px;
    font-size: 12px;
  }
  .time {
    margin-top: 10px;
    font-size: 10px;
    color: #838383;
    text-align: right;
  }
}
</style>
